import includes from "lodash/includes";
import { handleActions } from "redux-actions";

import { updateById } from "utils";

export default handleActions(
  {
    INTEGRATIONS_GET: {
      FULFILLED: (
        {
          currentUser: {
            company: { limitations },
          },
        },
        action
      ) => ({
        integrations: action.payload.integrations
          .filter(
            (i) => i.name !== "Zapier" || !includes(limitations, "deals") || i.type === "user"
          )
          .filter(
            (i) => i.name === "Zapier" || !includes(limitations, "assets") || i.type === "user"
          ),
      }),
    },
    INTEGRATION_CONNECT: {
      FULFILLED: (state, action) => ({
        integrations: updateById(state.integrations, action.payload.integration),
      }),
    },
    INTEGRATION_DISCONNECT: {
      FULFILLED: (state, action) => ({
        integrations: updateById(state.integrations, {
          id: action.meta.integrationID,
          status: "disconnected",
          credentials: null,
        }),
      }),
    },
  },
  {},
  { namespace: "_" }
);
